import { FC } from 'react';
import { AnvaQuote } from '@flows/src/types/anva';
import { Box } from '@wegroup/design-system';
import useFlowsProductSelectionStore from '@flows/src/store/zustand/flows-products/flowsProductSelectionStore';
import AnvaProductCartWidgetItem from '@flows/src/components/flow-products/quotes/cart/AnvaProductCartWidgetItem';

interface Props {
  quotes: AnvaQuote[];
}

const AnvaProductCartWidgetItems: FC<Props> = ({ quotes }) => {
  const removeFromSelected = useFlowsProductSelectionStore(
    (state) => state.removeFromSelected,
  );

  const handleRemove = (id: string, index: number) => {
    removeFromSelected(id, index);
  };

  return (
    <Box maxH="sm" overflowY="auto">
      <Box
        height={`${quotes.length * 50}px`}
        transition="0.2s"
        overflow="hidden"
      >
        {quotes.map((quote) => (
          <AnvaProductCartWidgetItem
            key={`${quote.anva_product_id}-${quote.index}`}
            data={quote}
            onRemove={() => handleRemove(quote.anva_product_id, quote.index)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default AnvaProductCartWidgetItems;
